import React, { useId } from "react";
import PropTypes from "prop-types";

import Divider from "assets/svg/divider.svg";

import styles from "./styles.module.css";

const FooterTabPanel = ({ categories }) => {
  const id = useId();
  return (
    <div className={styles.wrapper}>
      {categories?.map((category, index) => (
        <div key={`${id}+${index}`} className={styles.contentWrapper}>
          {category?.title && <span className={styles.title}>{category.title}</span>}
          <div className={styles.categorys}>
            {category?.children.map((child, childIndex) => (
              <React.Fragment key={`${id}-${childIndex}`}>
                <a href={child?.href} className={styles.categoryName} title={child?.name}>
                  {child?.name}
                </a>
                {category?.children?.length - 1 !== childIndex && <Divider className={styles.divider} />}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

FooterTabPanel.propTypes = {
  categories: PropTypes.array,
};

export default FooterTabPanel;
